import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

interface CommandSearchButtonProps {
  onOpenCommand: () => void;
}

export function CommandSearchButton({ onOpenCommand }: CommandSearchButtonProps) {
  return (
    <div className="flex-1 max-w-xl">
      <button
        onClick={onOpenCommand}
        aria-label="Abrir busca rápida (⌘K)"
        className={cn(
          "w-full h-11 pl-10 pr-4 rounded-xl text-left relative",
          "bg-muted/30 border border-border/50",
          "hover:bg-muted/50 hover:border-primary/30",
          "transition-all duration-180 ease-[cubic-bezier(0.16,1,0.3,1)]",
        )}
      >
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <span className="text-sm text-muted-foreground/60">
          Buscar hóspede, reserva ou quarto...
        </span>
        <kbd className="absolute right-3 top-1/2 -translate-y-1/2 hidden sm:inline-flex items-center gap-1 px-1.5 py-0.5 text-2.5 text-muted-foreground bg-muted/50 rounded border border-border/50">
          ⌘K
        </kbd>
      </button>
    </div>
  );
}
